import type { GetOptions, AirwallexBalanceSnapshot } from "@/core";
import { repositoryHost } from "@/repositories";
import { serviceHost } from "@/services";
import { useQuery } from "@tanstack/react-query";

const databaseService = serviceHost.getDatabaseService();
const airwallexBalanceSnapshotRepository =
  repositoryHost.getAirwallexBalanceSnapshotRepository(databaseService);
const functionsService = serviceHost.getFunctionsService();

/** Live balances of our Airwallex accounts (fetched from Airwallex on demand). */
export const useAirwallexBalances = () =>
  useQuery({
    queryKey: ["airwallex-balances", "live"],
    queryFn: () => functionsService.getAirwallexBalances(),
    staleTime: 60_000,
  });

/** Stored daily balance snapshots in a date range, ascending by date. */
export const useAirwallexBalanceSnapshots = (range: {
  startDate: string; // "YYYY-MM-DD"
  endDate: string; // "YYYY-MM-DD"
}) =>
  useQuery({
    queryKey: ["airwallex-balance-snapshots", range.startDate, range.endDate],
    queryFn: () =>
      airwallexBalanceSnapshotRepository.getAll({
        queryConstraints: [
          { field: "date", operator: ">=", value: range.startDate },
          { field: "date", operator: "<=", value: range.endDate },
        ],
        orderBy: { field: "date", direction: "asc" },
        pagination: { limit: 1000 },
      } as GetOptions<AirwallexBalanceSnapshot>),
    enabled: !!range.startDate && !!range.endDate,
  });
